import BulkEditProvider from './BulkEditContext';
import BulkEdit from './BulkEdit';


let Index = () => {
    return (
        <BulkEditProvider>
            <BulkEdit />
        </BulkEditProvider>
    )
}

export default Index;